'use client'

import PropTypes from 'prop-types'
import { TimeRecordingDrawerEntry } from '../TimeRecordingDrawerEntry/TimeRecordingDrawerEntry'
import { TimeRecordingDateSeparator } from '../TimeRecordingDateSeparator/TimeRecordingDateSeparator'
import MUIStack from '@mui/material/Stack'

export const TimeRecordingActiveTimer = ({
  activeTimer = {},
  pauseTimer = () => console.log('timer paused'),
  clientNo,
  matterNo,
  handleSelectTimer
}) => {
  if (!activeTimer?.matterTimerId) return <div data-testid="TimeRecordingActiveTimer" />
  if (clientNo && activeTimer.clientNo !== clientNo && matterNo && activeTimer.matterNo !== matterNo) return null

  return (
    <MUIStack data-testid="TimeRecordingActiveTimer" gap={'10px'}>
      <TimeRecordingDateSeparator title={'Active'} sx={{ position: 'sticky', top: '24px', zIndex: 5 }} />
      <TimeRecordingDrawerEntry entry={activeTimer} onIconClick={pauseTimer} onClick={handleSelectTimer} />
    </MUIStack>
  )
}

TimeRecordingActiveTimer.propTypes = {
  activeTimer: PropTypes.object,
  pauseTimer: PropTypes.func,
  clientNo: PropTypes.string,
  matterNo: PropTypes.any,
  handleSelectTimer: PropTypes.func
}
